module.exports = __webpack_public_path__ + "static/media/dollar.047119ad.svg";